module.exports = __webpack_public_path__ + "img/index-vision-2.a7db0ef0.png";